import React, { useEffect, useState } from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getFuncFichaEmpleado } from '../../redux/func_ficha_empleados/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';
import UserHeadDetail from '../../components/UserHeadDetail';
import UserHeadDetailMenu from '../../components/UserHeadDetailMenu';
import moment from 'moment';

const GeneralInfo = props => {

  const dispatch = useDispatch();
  const data = useSelector(store => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(store => store.funcTabEmployeed.loadingFicha_Empleado);

  useEffect(() => {
    dispatch(getFuncFichaEmpleado(props.match.params.id, parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.id, props.match.params.type])

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
//para calculo de edad:


  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : (
              <>
                <UserHeadDetail data={data} type={props.match.params.type} />
                <div className="my-4">
                  <UserHeadDetailMenu id={props.match.params.id} type={props.match.params.type} />
                    <div className="mt-4 mb-3">
                    <div className="d-flex aling-items-center justify-content-between px-2">
                      <h5 className="font-weight-bold text-uppercase">DATOS GENERALES</h5>
                      <div>
                        <span className="text-muted mr-3"><i className="material-icons">perm_identity</i> Identidad: {data.identidad}</span>
                        <span className="text-muted mr-3"><i className="material-icons">cake</i> Fecha Nacimiento: {moment(data.fecha_cumpleaños).format('DD/MM/YYYY')}</span>
                        <span className="text-muted"><i className="material-icons">access_time</i> Edad:  {(moment().diff(moment(data.fecha_cumpleaños), 'years'))} 
                      {/* { parseInt(data.edad)}  */}
                      &nbsp;años</span>
                      </div>
                    </div>
                    <hr className="mb-3" />
                    <div className="mt-4 mb-3">
                      <Table variant="dark">
                        <tbody>
                          <tr>
                            <td><i className="material-icons mr-2">phone</i> Teléfono</td>
                            <td>{data.celular ? data.celular : (data.telefono ? data.telefono : 'Aún no se ha ingresado')}</td>
                          </tr>
                          <tr>
                            <td><i className="material-icons mr-2">email</i> Correo empresarial</td>
                            <td>{data.correo_empresarial ? data.correo_empresarial : 'No ingresado aún'}</td>
                          </tr>
                          <tr>
                            <td><i className="material-icons mr-2">email</i> Correo personal</td>
                            <td>{data.correo_personal ? data.correo_personal : 'No ingresado aún'}</td>
                          </tr>
                          <tr>
                            <td><i className="material-icons mr-2">blur_on</i> Género</td>
                            <td>{data.genero ? data.genero.toLowerCase() === 'f' ? 'Femenino' : 'Masculino' : 'No ingresado aún'}</td>
                          </tr>
                          <tr>
                            <td><i className="material-icons mr-2">transgender</i> Estado civil</td>
                            <td>{data.estado_civil ? data.Estado_Civil_List[0].nombre : 'No ingresado aún'}</td>
                          </tr>
                          <tr>
                            <td><i className="material-icons mr-2">lens</i> Edad</td>
                            <td>
                              {/* {data.edad ? parseInt(data.edad) : 'No ingresado aún'} */}
                              { data.fecha_cumpleaños ? (moment().diff(moment(data.fecha_cumpleaños), 'years'))+ ' años' : 'No ingresado aún'} 
                              </td>
                          </tr>
                          <tr>
                            <td><i className="material-icons mr-2">place</i> Domicilio</td>
                            <td>{data.domicilio ? data.domicilio : 'No ingresado aún'}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>
    </>
  )
}
export default GeneralInfo